module.exports = __webpack_public_path__ + "io.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/io.svg
// module id = 869
// module chunks = 0